<div class="text-center p-5" *ngIf="!isLoaded">
  <i class="fa fa-spin fa-spinner fa-2x"></i>
</div>

<div *ngIf="isLoaded">
  <p-table
    [value]="commsAttachments"
    [paginator]="false"
    selectionMode="single"
    [(selection)]="selectedAttachment"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="attachmentUrlFilenameTemplate">Filename</th>
        <th pSortableColumn="attachmentUrlTemplate">URL</th>
        <th pSortableColumn="attachmentContentType">Content Type</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr (dblclick)="editAttachment(item)" [pSelectableRow]="item">
        <td>{{ item.attachmentFilenameTemplate }}</td>
        <td>{{ item.attachmentUrlTemplate }}</td>
        <td>{{ item.attachmentContentType }}</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="ui-g">
    <div class="ui-g-12">
      <button
        *ngIf="selectedAttachment != null"
        pButton
        type="button"
        label="Delete"
        class="ui-button ui-button-danger btn-to-right pull-right"
        (click)="deleteAttachment()"
      ></button>

      <button
        *ngIf="selectedAttachment != null"
        pButton
        type="button"
        label="Edit"
        class="ui-button ui-button-default btn-to-right pull-right"
        (click)="editAttachment(selectedAttachment)"
      ></button>

      <button
        pButton
        type="button"
        label="Add"
        class="ui-button ui-button-primary ui-button-success btn-to-right pull-right"
        (click)="createAttachment()"
      ></button>
    </div>
  </div>

  <p-confirmDialog
    header="Confirmation"
    icon="fa-icon-circle"
    [style]="{ width: '425px' }"
    acceptLabel="Confirm"
    rejectLabel="Cancel"
  ></p-confirmDialog>

  <p-dialog
    [header]="isEditMode ? 'Edit Template Attachment' : 'Create Template Attachment'"
    [(visible)]="showForm"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '600px' }"
    [contentStyle]="{ overflow: 'visible' }"
  >
    <form [formGroup]="createEditForm">
      <div class="ui-g">
        <div class="ui-g-12">
          <input type="hidden" formControlName="id" />
          <div class="input-label">File Name Template</div>
          <div class="input-value">
            <input
              required
              pInputText
              formControlName="attachmentFilenameTemplate"
              maxlength="255"
              style="width: 100%"
            />
          </div>
          <input type="hidden" formControlName="commsTemplateId" />
        </div>
        <div class="ui-g-12">
          <div class="input-label">URL Template</div>
          <div class="input-value">
            <input
              pInputText
              required
              formControlName="attachmentUrlTemplate"
              maxlength="255"
              style="width: 100%"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="input-label">Content Type</div>
          <div class="input-value">
            <p-dropdown
              [options]="contentTypes"
              formControlName="attachmentContentType"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div class="d-flex w-100">
        <div class="flex-grow-1 text-right">
          <button
            pButton
            type="button"
            label="Cancel"
            class="ui-button ui-button-default"
            (click)="showForm = false"
          ></button>
          <button
            pButton
            type="button"
            label="Save"
            [disabled]="!createEditForm.valid"
            class="ui-button ui-button-success btn-green"
            (click)="save()"
          ></button>
        </div>
      </div>
    </form>
  </p-dialog>
</div>
